/**
  * @ngdoc component
  * @name common.component:ItxShopCartPackaging
  *  
  * @param {object} shopCart Default values
  *
  * @description
  * Modal with packaging options.
  * 
*/
(function () {

    'use strict';

    var ItxShopCartPackagingCmp = {
        bindings: {
            shopCart : '<'
        },
        controller: ItxShopCartPackagingCmpCtrl,
        templateUrl: 'shop-cart-packaging.component.html'
    };

    ItxShopCartPackagingCmpCtrl.$inject = [
        'ShopCartPackagingService',
        'ItxLoaderFct',
        'ngDialog',
        'ItxShopCartFct'
    ];

    function ItxShopCartPackagingCmpCtrl (
        ShopCartPackagingService,
        ItxLoaderFct,
        ngDialog,
        ItxShopCartFct
    ) {
        var _this = this;
        
        _this.$onInit = function () {
            _this.state = ShopCartPackagingService.getInitialState(_this.shopCart);
            // variable que indica que el articulo viene de sint
            let isSint = '2';
            _this.indomError = _this.shopCart.items.some((item) => item.stockLocations && item.stockLocations[0].stockLocationId === isSint);

            //Se añade esto porque back envia el precio como 2.95 en lugar de 295, si algun dia envian el precio bien habría que comentar esta linea y pasar directamente el packingGiftPrice a la función formatPrice
            let unformattedGiftPrice = null; 
            
            if(inditex.iStoreJSON.details.packingGiftPrice){
                unformattedGiftPrice = inditex.iStoreJSON.details.packingGiftPrice.toString().replace('.', '');
            }
            _this.price = inditex.formatPrice(unformattedGiftPrice);
            _this.showGiftTicket = inditex.iStoreJSON.details.showGiftTicket == 1;
        };

        _this.saveGift = function () {
            if (_this.form.$invalid) {
                return;
            }
            ItxLoaderFct.show();
            // MDECOMM-15956 SALES V19
            // se añade delete porque la API no elimina correctamente el packaging regalo de los items de cesta
                ShopCartPackagingService.deleteGiftPacking().then(function(){
                    ShopCartPackagingService.saveGift().then(function(){
                        ItxShopCartFct.getCart();
                        ngDialog.close();
                    }).finally(function(){
                        ItxLoaderFct.hide();
                    });
                }).catch(function(){
                    console.error('ERROR GIFT PACKING shop-cart-packaging.component SAVEGIFT');
                }).finally(function(){
                    ItxLoaderFct.hide();
                    ngDialog.close();
                });
        };

        _this.selectBox = function(type){
            _this.form.$pristine=false;
            ShopCartPackagingService.updateBox(type);
        }

        /**
         * @name  getFeedbackIconClass
         * @description
         * Gets the icon class to show when form has been submitted.
         * @returns {String} icon - Icon name
        */
        _this.getFeedbackIconClass= function(){
            return (_this.form.customMessage.$valid)? 'icon-check-input': 'icon-close-input';
        };

        _this.toggleGiftTicket=function(){
            _this.state.model.includeGiftTicket=_this.state.model.includeCustomMessage;
        };
        _this.checkCustomMessage=function(){
            if(!_this.state.model.includeGiftTicket &&_this.state.model.includeCustomMessage){
                _this.state.model.includeCustomMessage=false;
            }
        };
    }

    angular.module('itxApp.common')
        .component('itxShopCartPackaging', ItxShopCartPackagingCmp);

})();
